var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":_vm.type},on:{"click":function($event){_vm.$emit('click')}}},[_c('IconSave'),_c('span',{staticClass:"d-inline-block ml-2"},[_vm._v(_vm._s(_vm.computedLabel))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }